import { render, staticRenderFns } from "./forumsLayout.vue?vue&type=template&id=3126ba62&scoped=true&"
import script from "./forumsLayout.vue?vue&type=script&lang=js&"
export * from "./forumsLayout.vue?vue&type=script&lang=js&"
import style0 from "./forumsLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./forumsLayout.vue?vue&type=style&index=1&id=3126ba62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126ba62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFabTransition,VIcon,VNavigationDrawer,VRow})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
